export const darkTheme = {
    bg:"#282c34",
    bgLighter:"202020",
    text:"white",
    textSoft:"#aaaaaa",
    soft:"#373737",
    btnColor:"#55f56a84"
}

export const lightTheme = {
    bg:"#f9f9f9",
    bgLighter:"white",
    text:"black",
    textSoft:"#606060",
    soft:"#f5f5f5",
    softRed:"#red",
    btnColor:"green"
}